import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-button',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  @Input() public type: string = 'button';
  @Input() public label: string;
  @Input() public icon: string;
  @Input() public iconPos: 'left' | 'right' = 'left';
  @Input() public loading = false;
  @Input() public loadingIcon: string;
  @Input() public disabled = false;
  @Input() public styleClass: string;
  @Input() public styleSheet: Record<string, any>

  @Output() public onClick = new EventEmitter<any>();
  @Output() public onFocus = new EventEmitter<any>();
  @Output() public onBlur = new EventEmitter<any>();

  @ContentChild('contentTemplate') public readonly contentTemplate: TemplateRef<any>;
}
